import React from 'react';

import { HOW_I_WORK } from 'constants/texts';
import { SECTIONS } from 'constants/sections';

import Section from 'components/Section';

import './styles.scss';
import MarkdownParser from 'components/MarkdownParser';

function HowIWork() {
  return (
    <Section name={SECTIONS.HOW_I_WORK.name}>
      <div className="first-column">
        <h1 className="title">{HOW_I_WORK.title}</h1>
        <ul className="items-list">
          {HOW_I_WORK.sections.map(({ id, title }) => (
            <li key={`link-${id}`} className="list-item">
              <a href={`#${id}`}>{title}</a>
            </li>
          ))}
        </ul>
      </div>
      <div className="second-column">
        {HOW_I_WORK.sections.map(({ id, title, content }) => (
          <div key={`subsection-${id}`} className="value" id={id}>
            <h2 className="subsection-title">{title}</h2>
            <p className="subsection-content">
              <MarkdownParser>
                {content}
              </MarkdownParser>
            </p>
          </div>
        ))}
      </div>
    </Section>
  )
}

export default HowIWork;
